import { authService } from '../service/auth/auth-service'
import { errorUtil } from '../util/auth-error-util'
import { queryKeys } from '../util/query-keys'
import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

type RequestPasswordlessLoginInput = {
  email: string
  captchaToken?: string
}

export const useRequestPasswordlessLogin = (options?: {
  onError?: (error: Error) => void
}): {
  requestPasswordlessLogin: (input: RequestPasswordlessLoginInput) => void
  isLoading: boolean
  error: Error | null
} => {
  const navigate = useNavigate()

  const {
    mutate: requestPasswordlessLoginMutation,
    isLoading,
    error,
  } = useMutation<void, Error, RequestPasswordlessLoginInput>(
    async (input) => {
      await authService.requestPasswordlessLogin(input)
    },
    {
      mutationKey: queryKeys.requestPasswordlessLogin(),
      onSuccess: (_data, variables) => {
        navigate(`/auth/get-in/verify/${encodeURIComponent(variables.email)}`)
      },
      onError: (err) => {
        errorUtil.logError(err)
        options?.onError?.(err)
      },
    },
  )

  const requestPasswordlessLogin = async (input: RequestPasswordlessLoginInput): Promise<void> => {
    requestPasswordlessLoginMutation(input)
  }

  return {
    requestPasswordlessLogin,
    isLoading,
    error,
  }
}
